import { api } from "./client";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const lang = localStorage.getItem('lang') || 'en';

// Create a new category
export const createCategory = async (categoryData) => {
  try {
    const response = await api.post(
      `${API_BASE_URL}api/categories/create-category`,
      categoryData
    );
    return response.data;
  } catch (error) {
    console.error(
      "API createCategory error:",
      error?.response?.data || error.message
    );
    throw new Error(
      error?.response?.data?.message || "Failed to create category."
    );
  }
};

// Fetch all categories
export const getAllCategories = async () => {
  try {
    const response = await api.get(`${API_BASE_URL}api/categories/category-list`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Accept-Language': lang // Set the language header
      },
    });
    return response.data;
  } catch (error) {
    console.error("Fetch Categories API Error:", error);
    throw error;
  }
};

// Update a category
export const updateCategory = async (id, updatedData) => {
  try {
    const response = await api.put(
      `${API_BASE_URL}api/categories/update-category/${id}`,
      updatedData
    );
    return response.data;
  } catch (error) {
    console.error(
      "API updateCategory error:",
      error?.response?.data || error.message
    );
    throw new Error(
      error?.response?.data?.message || "Failed to update category."
    );
  }
};

// Delete a category
export const deleteCategory = async (id) => {
  const response = await api.delete(`${API_BASE_URL}api/categories/delete-category/${id}`);
  return response.data;
};


